import React from 'react';
import styled from 'styled-components';

const StyledCheckboxLabel = styled.span`
  font-size: 1.2rem;
`;

export default StyledCheckboxLabel;
